import axiosInstance from 'api/axios';

export interface IGenerateGhibliImageRequestPayload {
    image: File;
}

export interface IImageToImageRequestPayload {
    image_url: string;
    feature_name: string;
}

export interface ISaveGeneratedImagePayload {
    image_name: string;
    image_url: string;
    tool_type: string;
}

export const ImageToImageApis = {
    // Generate Ghibli image - fixed to match upscale implementation
    generateGhibliImage: async (payload: FormData) => {
      const response = await axiosInstance.private.post(
        '/api/v1/gen-ai/ghibli-image',
        payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      return response.data;
    },
  
    // Image to image
    imageToImage: async (
      payload: IImageToImageRequestPayload
    ) => {
      const response = await axiosInstance.private.post(
        '/api/v1/gen-ai/image-to-image',
        payload
      );
      return response.data;
    },

    // Save generated image
    saveGeneratedImage: async (payload: ISaveGeneratedImagePayload) => {
      const response = await axiosInstance.private.post(
        '/api/v1/gen-ai/save-image',
        payload
      );
      return response.data;
    },
}